import { getUsers } from "Infrastructure/Api/Api";
import { processResponse } from "Infrastructure/Api/ApiUtils";
import { useQuery } from "@tanstack/react-query";

export const USERS_LIST = "USERS_LIST";

export function useUserList() {
	return useQuery({
		queryKey: [USERS_LIST],
		queryFn: processResponse(() => getUsers()),
		retry: false,
		refetchInterval: false,
		refetchIntervalInBackground: false,
	});
}
